import React from 'react';
import { Toaster } from '@/components/ui/toaster';
import Layout from '@/components/Layout';
import HomePage from '@/pages/HomePage';
import AnimatedBackground from '@/components/AnimatedBackground';

function App() {
  return (
    <>
      <AnimatedBackground />
      <Layout>
        <HomePage />
      </Layout>
      <Toaster />
    </>
  );
}

export default App;